var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "deb44db6bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.304688 0 L 27.707031 0 L 27.707031 29 L 2.304688 29 Z M 2.304688 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#deb44db6bd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d1a12a",
    d: "M 16.558594 0.136719 C 15.804688 0.851562 14.964844 1.308594 14.222656 1.902344 C 13.386719 2.566406 12.738281 3.382812 12.1875 4.273438 C 11.46875 5.4375 11.148438 6.769531 10.835938 8.078125 C 10.488281 9.539062 10.308594 11.03125 10.394531 12.539062 C 10.453125 13.492188 10.519531 14.472656 10.859375 15.363281 C 11.230469 16.320312 11.84375 17.164062 12.40625 18.027344 C 13.386719 19.535156 14.8125 20.425781 16.371094 21.179688 C 17.78125 21.863281 19.253906 22.3125 20.777344 22.632812 C 22.46875 22.984375 24.15625 22.921875 25.835938 22.578125 C 26.265625 22.492188 26.6875 22.386719 27.109375 22.289062 C 27.324219 22.242188 27.523438 22.308594 27.628906 22.5 C 27.707031 22.648438 27.683594 22.8125 27.535156 22.957031 C 26.449219 24.023438 25.441406 25.167969 24.21875 26.078125 C 22.242188 27.554688 20.070312 28.574219 17.582031 28.855469 C 16.058594 29.03125 14.550781 28.988281 13.042969 28.746094 C 12.417969 28.648438 11.867188 28.296875 11.269531 28.082031 C 9.492188 27.433594 8.054688 26.285156 6.632812 25.074219 C 4.714844 23.441406 3.550781 21.363281 2.839844 18.988281 C 2.351562 17.367188 2.304688 15.699219 2.355469 14.027344 C 2.449219 11.054688 3.570312 8.433594 5.226562 6.042969 C 6.609375 4.039062 8.414062 2.433594 10.628906 1.363281 C 12.105469 0.65625 13.675781 0.214844 15.339844 0.128906 C 15.726562 0.113281 16.109375 0 16.558594 0.136719 Z M 16.558594 0.136719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.565242c2ebaed0429861a2a0201720e0.svg";
export { ForwardRef as ReactComponent };